var _linearGradient, _clipPath, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedux(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63,
    height: 20,
    role: "img",
    "aria-label": "Redux",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Redux") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 63,
    height: 20,
    fill: "#764abc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmIiByb2xlPSJpbWciIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+UmVkdXg8L3RpdGxlPjxwYXRoIGQ9Ik0xNi42MzQgMTYuNTA0Yy44Ny0uMDc1IDEuNTQzLS44NCAxLjUtMS43NTQtLjA0Ny0uOTE0LS43OTYtMS42NDgtMS43MDktMS42NDhoLS4wNjFhMS43MSAxLjcxIDAgMDAtMS42NDggMS43NjljLjAzLjQ3OS4yMjYuODY5LjQ5NCAxLjE1My0xLjA0OCAyLjAzOC0yLjYyMSAzLjUzNi01LjAwNSA0Ljc5NS0xLjYwMy44MzgtMy4yOTYgMS4xNTQtNC45NDQuOTMtMS4zNzgtLjE5NS0yLjQ1Ni0uODEtMy4xMTYtMS43OTktLjk4OC0xLjQ5OS0xLjA3OC0zLjExNi0uMjU1LTQuNzM0LjYtMS4xNyAxLjQ5OS0yLjAyMyAyLjA5OS0yLjQ0M2E5Ljk2IDkuOTYgMCAwMS0uNDItMS41NDNDLS44NjggMTQuNDA4LS40MTYgMTguNzUyLjkzMiAyMC44MDVjMS4wMDQgMS40OTggMy4wNTcgMi40NTYgNS4zMDQgMi40NTYuNiAwIDEuMjMtLjA0NCAxLjg0My0uMTk0IDMuODk3LS43NDkgNi44NDgtMy4wODYgOC41NDEtNi41MzJ6bTUuMzQ4LTMuNzQ2Yy0yLjMyLTIuNzI4LTUuNzM4LTQuMjI2LTkuNjM0LTQuMjI2aC0uNTFjLS4yNTMtLjU1NC0uODM3LS44OTktMS40OTgtLjg5OWgtLjA0NWMtLjk0MyAwLTEuNjc4LjgxLTEuNjQ3IDEuNzUzLjAzLjg5OC43OTQgMS42NDggMS43MDggMS42NDhoLjA3NGExLjY5IDEuNjkgMCAwMDEuNDk5LTEuMDQ5aC41NTVjMi4zMDkgMCA0LjQ5NS42NzQgNi40ODggMS45OTIgMS41MjcgMS4wMDUgMi42MjIgMi4zMjMgMy4yMzcgMy44OTcuNTM4IDEuMjg4LjUwOSAyLjU0Ny0uMDQ1IDMuNTk3LS44NTUgMS42NDctMi4yOTQgMi41MTctNC4xOTYgMi41MTctMS4xOTkgMC0yLjM2Ny0uMzc1LTIuOTY3LS42NDQtLjM2LjI5OC0uOTYuNzkzLTEuMzk0IDEuMDkzIDEuMzE4LjU5OCAyLjY1Mi45NDMgMy45NC45NDMgMi45MjIgMCA1LjA5NC0xLjY0NyA1LjkxOS0zLjIzNi44OTgtMS43OTguODI0LTQuODI0LTEuNDctNy40MTZ6TTYuNDkgMTcuMDQyYy4wMy44OTkuNzkzIDEuNjQ4IDEuNzA4IDEuNjQ4aC4wNmExLjY4OCAxLjY4OCAwIDAwMS42NDgtMS43NjhjMC0uOS0uNzc5LTEuNjQ3LTEuNjkzLTEuNjQ3aC0uMDZjLS4wNiAwLS4xNSAwLS4yMjYuMDI5LTEuMjQzLTIuMDk4LTEuNzY4LTQuMzQ3LTEuNTcyLTYuNzcyLjEyLTEuODI4LjcyLTMuNDE3IDEuNzk3LTQuNzM1LjktMS4xMjQgMi41OTMtMS42OCAzLjc0Ny0xLjcwOCAzLjIzNi0uMDYxIDQuNTg1IDMuOTcxIDQuNjg5IDUuNTc0bDEuNDk4LjQ1QzE3Ljc0MSAzLjE5NyAxNC42ODYuNjIgMTEuNzY0LjYyIDkuMDIuNjIgNi40OSAyLjYxMyA1LjQ3IDUuNTM1IDQuMDc3IDkuNDMgNC45OTEgMTMuMTc3IDYuNyAxNi4xNzRjLS4xNS4xOTUtLjI0LjUzOS0uMjEuODY4eiIvPjwvc3ZnPg=="
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 405,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 350
  }, "Redux"), /*#__PURE__*/React.createElement("text", {
    x: 405,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 350
  }, "Redux"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedux);
export default __webpack_public_path__ + "static/media/redux.4591c58f19dab0f56bfdb1e77cf9f910.svg";
export { ForwardRef as ReactComponent };